export default __webpack_public_path__ + "assets/h2.01d21831.svg";